// extracted by mini-css-extract-plugin
export default {"BoxFilter__container":"BoxFilter_BoxFilter__container__+iem2","boxFilter__search":"BoxFilter_boxFilter__search__Oq8LG"};